/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuImage } from '@neutron/react';

export const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 100vh;
`;
export const BackgroundImage = styled(NeuImage)`
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
  object-fit: cover;
  figure,
  div,
  img {
    height: 100%;
    width: 100%;
  }
`;

export const ErrorContainer = styled.div`
  position: absolute;
  z-index: 2;
  top: 15%;
  left: 10%;
`;
export const Text = styled.p`
  margin: 15px 0 !important;
  font-size: 25px !important;
`;

export const H1 = styled.h1`
  font-size: 125px !important;
  min-height: 1em;
  margin-left: -0.75rem;
`;

export const H4 = styled.h4`
  font-size: 50px !important;
  min-height: 1em;
  margin-left: -0.25rem;
`;

export const FeatureNotEnabledContainer = styled(StyledDiv)<{
  offsetHeight: number;
}>`
  height: calc(100vh - ${({ offsetHeight = 0 }) => offsetHeight}px);
`;
